import React, { useState } from 'react';
import download from '../utils/downloadExcel';
import Config from '../config/Config';
import { Button, CircularProgress } from '@mui/material';
import axios from 'axios';
import moment from 'moment';
import PropTypes from 'prop-types';

function SummaryDataExport(props) {
    const { restauId, startDate, endDate, restauTimeZone } = props;
    const [loading, setLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const reportNamePrefix = 'OrderSummaryReport_';

    // to export the data related to all the items from all the Online orders
    async function exportOnlineOrderData() {
        setLoading((prevstatus) => !prevstatus);
        setIsError(false);
        const token = await window.customerApp.auth().currentUser.getIdToken();
        let config = {
            headers: {
                token: token,
            },
        };

        let reqBody = {
            restauId: restauId,
            startDate: startDate,
            endDate: endDate,
        };

        let dataToExport = [];

        axios
            .post(Config.getOrderSummaryReportByDay, reqBody, config)
            .then((response) => {
                console.log(response.data);
                //debugger;
                if (response.status === 200 && response.data) {
                    response.data.forEach((element) => {
                        dataToExport.push({
                            Date: element.date,
                            '#OnlineOrders': element.onlineOrderCount,
                            PreTaxOnlineAmount: element.preTaxOnlineAmount,
                            OnlineTips: element.onlineTips,
                            '#DineInOrders': element.dineInOrderCount,
                            PreTaxDineInAmount: element.preTaxDineInAmount,
                            DineInTips: element.dineInTips,
                        });
                    });

                    setLoading((prevstatus) => !prevstatus);
                    download.excelDownload(
                        dataToExport,
                        reportNamePrefix +
                            moment(new Date()).format('DD-MM-YYYY_hhmmss') +
                            '.xlsx',
                        'OrderSummaryByDay'
                    );
                } else {
                    setLoading((prevstatus) => !prevstatus);
                    setIsError(true);
                }
            })
            .catch(function (error) {
                setLoading((prevstatus) => !prevstatus);
                setIsError(true);
                console.log(error);
            });
    }

    return (
        <>
            <Button
                color="primary"
                variant="contained"
                disabled={loading}
                onClick={() => exportOnlineOrderData()}
                style={{
                    height: 'max-content',
                }}
            >
                Export Summary Data to Excel
            </Button>
            {loading && <CircularProgress color="secondary" size={30} />}
            {isError && (
                <p
                    style={{
                        color: 'red',
                        fontWeight: 'normal',
                        fontSize: '0.85rem',
                    }}
                >
                    Failed to export the data.
                </p>
            )}
        </>
    );
}

SummaryDataExport.propTypes = {
    restauId: PropTypes.string.isRequired,
    startDate: PropTypes.instanceOf(Date).isRequired,
    endDate: PropTypes.instanceOf(Date),
};

export default SummaryDataExport;
